import { Component } from '@theme/component';

/**
 * A custom element that handles the floating email subscription form.
 *
 * @typedef {Object} Refs
 * @property {HTMLDivElement} headingContainer
 * @property {HTMLDivElement} successContainer
 * @property {HTMLDivElement} formContainer
 * @property {HTMLFormElement} emailSignupBlock
 * @property {HTMLButtonElement} expandButton
 * @property {HTMLButtonElement} closeButton
 * 
 * @extends {Component<Refs>}
 */
export class FloatingEmailSignupComponent extends Component {
	requiredRefs = [
		'headingContainer',
		'successContainer',
		'formContainer',
		'emailSignupBlock',
		'expandButton',
		'closeButton',
	];

	connectedCallback() {
		super.connectedCallback();

		if (!localStorage.getItem("isDiscountSubmit")) {
			this.classList.remove('hidden');
		}

		const { headingContainer, successContainer, formContainer, emailSignupBlock, expandButton } = this.refs;

		if (headingContainer && successContainer && formContainer && emailSignupBlock && expandButton) {
			if (emailSignupBlock.hasAttribute('success')) {
				this.setAttribute('success', '');
				localStorage.setItem("isDiscountSubmit", "true");
				headingContainer.hidden = true;
				successContainer.hidden = false;
				formContainer.hidden = true;
				expandButton.hidden = true;
			}
		}
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	close() {
		this.remove();
	}

	expandForm() {
		const { formContainer, expandButton } = this.refs;

		if (!formContainer || !expandButton) return;

		formContainer.hidden = false;
		expandButton.hidden = true;
	}
}

if (!customElements.get('floating-email-signup-component')) {
  customElements.define('floating-email-signup-component', FloatingEmailSignupComponent);
}